export const isNumberCoercible = (value: unknown): value is number | Date => {
  return typeof value === 'number' || value instanceof Date;
};
